import RewardsCarousel from './RewardsCarousel';

export default RewardsCarousel;